import { Icon, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { Device } from 'types';
import {
    NetworkWifi,
    SignalCellularConnectedNoInternet0Bar,
    SignalWifi3Bar,
    SignalWifi4Bar,
    SignalWifi2Bar,
    SignalWifi1Bar,
    SignalCellular1Bar,
    SignalCellular2Bar,
    SignalCellular3Bar,
    SignalCellular4Bar,
} from '@mui/icons-material';

const DeviceSignalIcon = (props: Device) => {
    const [tooltip, setTooltip] = useState('');
    const [icon, setIcon] = useState(<div></div>);

    useEffect(() => {
        if (props.connection_type === 'wifi') {
            setIcon(<NetworkWifi data-testid="NetworkWifi"></NetworkWifi>);
            setTooltip('wifi');

            if (props.lastReading?.rssi) {
                const rssi = props.lastReading.rssi;
                setIconForWifi(rssi);
            }
        } else if (props.connection_type === 'cell') {
            setIcon(
                <SignalCellularConnectedNoInternet0Bar data-testid="SignalCellularConnectedNoInternet0Bar"></SignalCellularConnectedNoInternet0Bar>
            );
            setTooltip('Unknown');

            const rsrp = props.rsrp_avg ?? props.lastReading?.rsrp;
            setIconForCell(rsrp);
        }
    }, [props]);

    const setIconForWifi = (rssi: number) => {
        if (rssi > -67) {
            setIcon(
                <SignalWifi4Bar data-testid="SignalWifi4Bar"></SignalWifi4Bar>
            );
            setTooltip('Excellent');
        } else if (rssi > -70) {
            setIcon(
                <SignalWifi3Bar data-testid="SignalWifi3Bar"></SignalWifi3Bar>
            );
            setTooltip('Good');
        } else if (rssi > -80) {
            setIcon(
                <SignalWifi2Bar data-testid="SignalWifi2Bar"></SignalWifi2Bar>
            );
            setTooltip('Fair');
        } else {
            setIcon(
                <SignalWifi1Bar data-testid="SignalWifi1Bar"></SignalWifi1Bar>
            );
            setTooltip('Poor');
        }
    };

    const setIconForCell = (rsrp: number) => {
        if (rsrp) {
            if (rsrp > -80) {
                setIcon(
                    <SignalCellular4Bar data-testid="SignalCellular4Bar"></SignalCellular4Bar>
                );
                setTooltip('Excellent');
            } else if (rsrp > -90) {
                setIcon(
                    <SignalCellular3Bar data-testid="SignalCellular3Bar"></SignalCellular3Bar>
                );
                setTooltip('Good');
            } else if (rsrp > -100) {
                setIcon(
                    <SignalCellular2Bar data-testid="SignalCellular2Bar"></SignalCellular2Bar>
                );
                setTooltip('Fair');
            } else {
                setIcon(
                    <SignalCellular1Bar data-testid="SignalCellular1Bar"></SignalCellular1Bar>
                );
                setTooltip('Poor');
            }
        }
    };

    return (
        <div data-testid="DeviceSignalIcon">
            <Tooltip data-testid="Tooltip" title={tooltip}>
                <Icon>{icon}</Icon>
            </Tooltip>
        </div>
    );
};

export default DeviceSignalIcon;
